import { DashboardWidgetType, DashboardWidgetUnion } from '../types';

export const getDefaultPortraitDashboardLayout = (): DashboardWidgetUnion[] => [
  {
    id: '1',
    type: DashboardWidgetType.NEXT_EVENT,
    positions: { portrait: { width: 12, height: 4, left: 0, top: 0 } },
  },
  {
    id: '2',
    type: DashboardWidgetType.CHECKLISTS,
    positions: { portrait: { left: 0, top: 4, width: 6, height: 4 } },
  },
  {
    id: '3',
    type: DashboardWidgetType.STICKY_NOTE,
    positions: { portrait: { left: 6, top: 4, width: 6, height: 4 } },
  },
  {
    id: '4',
    type: DashboardWidgetType.GOAL_CAROUSEL,
    positions: { portrait: { left: 0, top: 8, width: 12, height: 4 } },
  },
];
